document.addEventListener('DOMContentLoaded', function () {
  var quiz = document.getElementById('cardsQuizForm');
  var game = document.getElementById('cardsGame');
  var params = new URLSearchParams(window.location.search);

  if (!quiz || !game) return;

  if (window.cardsFormSuccess || params.get('customer_posted') === 'true') {
    quiz.classList.add('hidden');
    game.classList.remove('hidden');

    // Shopify returns to the form anchor (#cardsContact). Keep the success
    // screen at the top instead of allowing that anchor to scroll the page.
    window.requestAnimationFrame(function () {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    });

    window.addEventListener('load', function () {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }, { once: true });
  }
});
